import type { ReactNode } from 'react';
import { LoadingSkeleton } from '@/components/feedback/LoadingSkeleton';
import { usePermission } from '@/hooks/usePermission';

interface RequirePermissionProps {
  action: string;
  children: ReactNode;
}

export function RequirePermission({ action, children }: RequirePermissionProps) {
  const { can, isLoading } = usePermission();

  if (isLoading) {
    return <LoadingSkeleton rows={4} />;
  }

  if (!can({ action })) {
    return (
      <div className='rounded-md border bg-card p-4 text-sm text-muted-foreground'>
        No tenés permisos para acceder a esta sección.
      </div>
    );
  }

  return <>{children}</>;
}
